export const tracker = new Worker(new URL('./tracker.ts', import.meta.url));
export const creative = new Worker(new URL('./creative.ts', import.meta.url));
export const creativeSize = new Worker(new URL('./creativeSize.ts', import.meta.url));
export const socket = new Worker(new URL('./socket.ts', import.meta.url));
export const fetchAsset = new Worker(new URL('./fetchAsset.ts', import.meta.url));
export const fetchHistory = new Worker(new URL('./fetchHistory.ts', import.meta.url));
